import React from 'react';
import PropTypes from 'prop-types';
import './AutoCompleteOptionContainer.css';
const AutoCompleteOptionContainer = ({ id, options, show = false, activeOption = -1, onSelect, onActiveOptionChange }) => {

  const nothing = <></>;
  if (!show) {
    return nothing;
  }

  return (
      <div className="auto-complete-option-container">
          <ul id={id} className="auto-complete-option-list" role="listbox">
              {options.map((option, i) =>
              // Keyboard selection is handled by the combobox input using aria-activedescendant.
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events
              <li
                id={`${id}-option-${i}`}
                key={i}
                role="option"
                aria-selected={activeOption === i}
                onMouseDown={(event) => event.preventDefault()}
                onMouseEnter={() => onActiveOptionChange(i)}
                onClick={() => onSelect(i)}>
                  {option}
                </li>
              )}
          </ul>
      </div>
  );
};

AutoCompleteOptionContainer.propTypes = {
  options: PropTypes.array.isRequired,
  id: PropTypes.string,
  show: PropTypes.bool.isRequired,
  activeOption: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  onActiveOptionChange: PropTypes.func
};

AutoCompleteOptionContainer.defaultProps = {
  id: 'auto-complete-options',
  onActiveOptionChange: () => {}
};

export default AutoCompleteOptionContainer;
